// extracted by mini-css-extract-plugin
export default {"form":"AuthForm_form__qHAMt","formForgotPassword":"AuthForm_formForgotPassword__OFo5i","formSubmit":"AuthForm_formSubmit__8mmYa"};